import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class DateRangeInput extends Vue {
  @Prop() rangeDate: string[];
  @Prop() label: string;

  private rangeDateText: string[] = [];

  @Emit('input')
  resetRangeDate(): string[] {
    return [];
  }

  @Emit('input')
  changeRangeDate(rangeDate: string[]): string[] {
    let result = rangeDate;
    if (moment(rangeDate[0]) > moment(rangeDate[1])) {
      result = rangeDate.reverse();
    }
    return result;
  }

  @Watch('rangeDate')
  onRangeDateChanged(rangeDate: string[]): void {
    this.rangeDateText = rangeDate;
  }
}
